// client-side API wrappers (talk to local proxy)

const API_PATH = process.env.REACT_APP_NODE_ENV === 'dev' ? "http://localhost:3001/sitegeneration/api/sitewizard" : "/sitegeneration/api/sitewizard";

export async function createSitewizard(payload) {
  const res = await fetch(API_PATH, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload)
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.error || JSON.stringify(data));
  return data;
}
